import { supabase } from './supabaseClient';

/** True when password login succeeded but a verified MFA factor still needs a TOTP code. */
export async function needsMfaChallenge(client = supabase) {
  const { data, error } = await client.auth.mfa.getAuthenticatorAssuranceLevel();
  if (error) throw error;
  return data?.currentLevel === 'aal1' && data?.nextLevel === 'aal2';
}

export async function listVerifiedTotpFactors(client = supabase) {
  const { data, error } = await client.auth.mfa.listFactors();
  if (error) throw error;
  const totp = Array.isArray(data?.totp) ? data.totp : [];
  return totp.filter((f) => f?.status === 'verified');
}

export async function getPrimaryVerifiedTotpFactor(client = supabase) {
  const factors = await listVerifiedTotpFactors(client);
  return factors[0] ?? null;
}

export async function verifyTotpCode(factorId, code, client = supabase) {
  const trimmed = String(code || '').replace(/\s/g, '');
  if (!factorId) throw new Error('Doğrulama faktörü bulunamadı.');
  if (!/^\d{6}$/.test(trimmed)) throw new Error('6 haneli doğrulama kodunu girin.');

  if (typeof client.auth.mfa.challengeAndVerify === 'function') {
    const { data, error } = await client.auth.mfa.challengeAndVerify({
      factorId,
      code: trimmed,
    });
    if (error) throw error;
    return data;
  }

  const { data: challenge, error: challengeError } = await client.auth.mfa.challenge({ factorId });
  if (challengeError) throw challengeError;

  const { data, error } = await client.auth.mfa.verify({
    factorId,
    challengeId: challenge.id,
    code: trimmed,
  });
  if (error) throw error;
  return data;
}

export async function enrollTotpFactor(friendlyName = 'MMJ Panel', client = supabase) {
  const { data, error } = await client.auth.mfa.enroll({
    factorType: 'totp',
    friendlyName,
  });
  if (error) throw error;
  return data;
}

export async function unenrollFactor(factorId, client = supabase) {
  const { data, error } = await client.auth.mfa.unenroll({ factorId });
  if (error) throw error;
  return data;
}

export function mfaErrorMessage(err) {
  const msg = err?.message || String(err || '');
  if (/invalid.*(code|totp)|wrong code|mfa code/i.test(msg)) {
    return 'Doğrulama kodu hatalı veya süresi doldu. Tekrar deneyin.';
  }
  if (/mfa|factor|totp/i.test(msg) && /disabled|not enabled|enroll/i.test(msg)) {
    return 'VDS Auth üzerinde TOTP/MFA kapalı görünüyor. GOTRUE_MFA_TOTP_ENROLL_ENABLED ve VERIFY_ENABLED açık olmalı.';
  }
  return msg || 'Doğrulama başarısız.';
}
